import saleService from '../../services/sale-service';


const state = {

    loading: false,
    sales: [],
    sale_items: [],
    sales_rpt:[],
    srpt_data:{
        all_sales: {},
        cash_sale_sum: 0,
        credit_sale_sum: 0,
        credit_payments_sum: 0,
        vendor_sale_sums: [] //vendor  sale sums (vcass)
    },
    error: null,
    recentSale: {}
}

const actions = {
    getAll({ commit, state }) {
        commit('Loading');

        saleService.getAll()
            .then(
                sales => {
                    commit('Success', sales.data)
                    commit('Failure', null)
                },
                error => commit('Failure', error)
            ).then(() => {
                let trans_items = state.sales.map(x => x.items);

                var merged_items = Array.prototype.concat.apply([], trans_items);

                commit('All_Sale_Items', merged_items)


            });
    },
    add({ commit, state }, data) {
        commit('Failure', null)
        commit('Loading');
        saleService.create(data)
            .then(
                response => {
                    if (response.status == 200) {
                        data.id = response.data.id;
                        data.created_at = response.data.created_at;
                        commit('Add', data)
                        commit('Recent', data)
                        
                    }
                },
                error => commit('Failure', error)
            )

    },
    delete({ commit, state }, data) {
        saleService.delete(data.sale.id)
            .then(
                response => {
                    state.sales.splice(data.index, 1)
                    commit('Failure', null)
                },
                error => commit('Failure', error)
            )
    },
    update({ commit, state }, data) {
        commit('Loading');
        commit('Failure', null)
        saleService.update(data.sale.id, data.sale)
            .then(
                success => {
                    Object.assign(state.sales[data.index], data.sale);
                    
                },
                error => commit('Failure', error)
            )

    },
    undo_sale() {

    },
    clearRecent({ commit }) {
        commit('Recent', {})
    },
    allSaleItems({ state, commit }) {
        //console.log(sales.data)
        let trans_items = state.sales.map(x => x.items);

        var merged_items = Array.prototype.concat.apply([], trans_items);

        commit('All_Sale_Items', merged_items)
    },
    getSalesRpt({commit},data){
        commit('Loading');
        commit('Failure', null)
        saleService.getSalesRpt(data).then(
            response=>{
               // console.log("from store",response.data)
                commit('SaleRpt', response.data)
            },
            error=>{
                commit('Failure', error)
            }
        )
    }
}


const mutations = {
    Loading(state) {
        state.loading = true;
    },
    Success(state, sales) {
        state.sales = sales;
        //state.loading = false;
    },
    Recent(state, sale) {

        state.recentSale = sale;
        //state.loading = false;
    },
    Failure(state, error) {
        state.error = error;
        state.loading =false;
    },
    Add(state, val) {
        state.sales.unshift(val);
        state.loading = false;
    },
    All_Sale_Items(state, val) {
        state.sale_items = val
    },
    SaleRpt(state,val){
        state.loading =false
        state.sales_rpt = val


        let groupSales = {
            cashSales: [],
            creditSales: []
          };

          let creditSalesDebtPayments = [];

          //grouping sales to credit and cash
          val.forEach(x => {
            if (x.mop == "Cash") {
              groupSales.cashSales.push(x);
            }
            if (x.mop == "Credit") {
              groupSales.creditSales.push(x);
            }
          });

          //putting all credit sale debt payments into 1 array
          if (groupSales.creditSales && groupSales.creditSales.length > 0) {
            creditSalesDebtPayments = groupSales.creditSales
              .map(c => {
                return c.debtpayments;
              })
              .reduce((pre, curr) => {
                return [...pre, ...curr];
              });
          }

          //setting report data to be used in report
          state.srpt_data.all_sales = groupSales;
          state.srpt_data.credit_sale_sum =
            groupSales && groupSales.creditSales
              ? groupSales.creditSales.reduce((sum, x) => {
                  return (sum += parseFloat(x.payable_amount));
                }, 0)
              : 0;

          state.srpt_data.cash_sale_sum =
            groupSales && groupSales.cashSales
              ? groupSales.cashSales.reduce((sum, x) => {
                  return (sum += parseFloat(x.payable_amount));
                }, 0)
              : 0;

          state.srpt_data.credit_payments_sum = creditSalesDebtPayments
            ? creditSalesDebtPayments.reduce((sum, x) => {
                return (sum += parseFloat(x.amount));
              }, 0)
            : 0;

          //grouping vendor sale sums
          state.srpt_data.vendor_sale_sums = groupVendorSaleSum(
            val
          );


    }
}

const getters = {
    SALES: state => {
        return state.sales
    },
    RECENT_SALE: state => {
        return state.recentSale
    },
    SALES_ITEMS: state => {
        return state.sale_items
    },
    SALES_RPT: state => {
        return state.sales_rpt
    },
    SRPT_DATA: state => {
        return state.srpt_data
    },
    SALE_ERROR: state => {
        return state.error
    },
    SALES_LOADING: state => {
        return state.loading
    },

}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


export function groupVendorSaleSum(sales) {
    if (sales && sales.length > 0) {
      let c = sales.reduce(
        (groups, item) => ({
          //grouped sales
          ...groups,
          [item.staff]: [...(groups[item.staff] || []), item]
        }),
        []
      );

     // console.log("ccccc", c);

      let vsgrpd = c
        ? Object.keys(c).map(key => {
            var oneVendorSales = c[key]; //picking group of individual vendor sales to calculate total sale (on cash/credit based on sale param) by that vendor

            return {
              vendor: key,
              cs: oneVendorSales.reduce((sum, x) => {
                if (x.mop == "Cash") {
                  return (sum += parseFloat(x.payable_amount));
                }
              }, 0),
              crs: oneVendorSales.reduce((sum, x) => {
                if (x.mop == "Credit") {
                  return (sum += parseFloat(x.payable_amount));
                }
              }, 0)
            };
          })
        : null;
      return vsgrpd;
    }
  }